// extracted by mini-css-extract-plugin
export default {"loadingModal":"Loading_loadingModal__kDOop","text":"Loading_text__8LhVx","loader":"Loading_loader__MrKf6","spin":"Loading_spin__p7CvH"};